import { FC, SVGProps } from "react";
import { UTSLocale } from "@smile2impress/attraction-constants";
import {
    ExtraLogoEsIcon,
    ExtraLogoFrIcon,
    ExtraLogoItIcon,
    ExtraLogoPtIcon,
    ExtraLogoUaIcon,
    ExtraLogoUkIcon,
    ExtraLogoUsIcon,
    ExtraLogoNlIcon,
    ExtraLogoDeIcon,
    ExtraLogoSeIcon,
} from "@smile2impress/components";

import { useUTSLocaleContext } from "../../../context/utsLocaleContext";

export interface ExtraLogoProps extends SVGProps<SVGSVGElement> {
    width?: string;
    height?: string;
    mono?: boolean;
}

export const ExtraLogo: FC<ExtraLogoProps> = ({ ...props }) => {
    const { locale } = useUTSLocaleContext();

    switch (locale) {
        case UTSLocale.ITALY_IT:
            return <ExtraLogoItIcon {...props} />;
        case UTSLocale.PORTUGAL_PT:
            return <ExtraLogoPtIcon {...props} />;
        case UTSLocale.FRANCE_FR:
            return <ExtraLogoFrIcon {...props} />;
        case UTSLocale.UKRAINE_UK:
            return <ExtraLogoUaIcon {...props} />;
        case UTSLocale.GB_EN:
            return <ExtraLogoUkIcon {...props} />;
        case UTSLocale.US_EN:
            return <ExtraLogoUsIcon {...props} />;
        case UTSLocale.NL_NL:
            return <ExtraLogoNlIcon {...props} />;
        case UTSLocale.GERMANY_DE:
            return <ExtraLogoDeIcon {...props} />;
        case UTSLocale.SWEDEN_SE:
            return <ExtraLogoSeIcon {...props} />;
        default:
            return <ExtraLogoEsIcon {...props} />;
    }
};
